import { DeviationResourceType } from '../types/deviation';
import { ResourceType } from '../types/resource';
export function getRecipientSectionName(typeId) {
    var recipientType;
    if (DeviationResourceType[typeId]) {
        recipientType = 'deviation';
    }
    else if (typeId === ResourceType.COMMENT) {
        recipientType = 'comments';
    }
    return recipientType;
}
export var badgeNotificationsFilter = function (badgeName) { return function (notification) { var _a, _b; return ((_b = (_a = notification.params) === null || _a === void 0 ? void 0 : _a.badge) === null || _b === void 0 ? void 0 : _b.name) === badgeName; }; };
//# sourceMappingURL=utils.js.map